import {
  CommonMFE,
  Helpers,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import React from "react";
import { TitleWrapper } from "./TitleWrapper";
import { TpdCta, TpdCtaBox, TpdLinksContainer } from "./App.style";

/** Style Enum */
export enum BOX_COLOR_KEYS {
  NERO_IN_TRASPARENZA = "Nero in trasparenza",
  BIANCO_IN_TRASPARENZA = "Bianco in trasparenza",
  VERDE_IN_TRASPARENZA = "Verde in trasparenza",
  BLU_IN_TRASPARENZA = "Blu in trasparenza",
  ARANCIONE_IN_TRASPARENZA = "Arancione in trasparenza",
  AZZURRO = "Azzurro",
}
/** Style Mapping */
export const BOX_COLORS = {
  [BOX_COLOR_KEYS.NERO_IN_TRASPARENZA]: "rgba(0,0,0,.4)",
  [BOX_COLOR_KEYS.BIANCO_IN_TRASPARENZA]: "rgba(255,255,255,.4)",
  [BOX_COLOR_KEYS.BLU_IN_TRASPARENZA]: "rgba(1,105,180,.8)",
  [BOX_COLOR_KEYS.VERDE_IN_TRASPARENZA]: "rgba(89,166,39,.8)",
  [BOX_COLOR_KEYS.ARANCIONE_IN_TRASPARENZA]: "rgba(233,78,16,.8)",
  [BOX_COLOR_KEYS.AZZURRO]: "",
};

export const BOX_COLORS_MOBILE = {
  [BOX_COLOR_KEYS.NERO_IN_TRASPARENZA]: "rgba(0,0,0)",
  [BOX_COLOR_KEYS.BIANCO_IN_TRASPARENZA]: "rgba(255,255,255)",
  [BOX_COLOR_KEYS.BLU_IN_TRASPARENZA]: "rgba(1,105,180)",
  [BOX_COLOR_KEYS.VERDE_IN_TRASPARENZA]: "rgba(89,166,39)",
  [BOX_COLOR_KEYS.ARANCIONE_IN_TRASPARENZA]: "rgba(233,78,16)",
  [BOX_COLOR_KEYS.AZZURRO]: "",
};

export const getRgbaBoxColorBy = (boxColorKey) => {
  return BOX_COLORS[boxColorKey] || "";
};

export const getRgbaBoxColorMobileBy = (boxColorKey) => {
  return BOX_COLORS_MOBILE[boxColorKey] || "";
};

export const BOX_POSITIONS = {
  Sinistra: "left",
  Destra: "right",
  Nascosto: "hidden",
};

type TBoxContentWrapperProps = {
  id: string;
  __host__: CommonMFE.Types.THost;
  isEditMode: boolean;
  config: any;
};

/** Box */
export const BoxContentWrapper = (props: TBoxContentWrapperProps) => {
  const { id: containerID, __host__, isEditMode, config } = props;

  const tipologiaTesto = Helpers.RemoteHelper.getSelectedValue(
    config["Tipologia Testo"].value
  );

  const boxColor = Helpers.RemoteHelper.getSelectedValue(
    config["coloreBox"].value
  );

  const title = config["Title"];
  const testo = config["Testo"];

  const link1 = config["Link1"];
  const link2 = config["Link2"];

  const isTitleVisible =
    boxColor === BOX_COLOR_KEYS.BLU_IN_TRASPARENZA ||
    boxColor === BOX_COLOR_KEYS.ARANCIONE_IN_TRASPARENZA ||
    boxColor === BOX_COLOR_KEYS.VERDE_IN_TRASPARENZA;

  const getBoxPositionBy = (boxPositionKey) => {
    return BOX_POSITIONS[boxPositionKey] || (isEditMode ? "opaque" : "hidden");
  };

  return (
    <div
      className={`visore-no-carosello-box ${getBoxPositionBy(tipologiaTesto)}`}
    >
      <div className="box-content-wrapper">
        {isTitleVisible && (
          <TitleWrapper
            id={containerID}
            __host__={__host__}
            config={config}
            isEditMode={isEditMode}
          />
        )}

        <div className={`box-subtitle`}>
          <ReactMFE.Remote
            id={CommonMFE.generateID(
              containerID,
              `${MFE_NAMES.tpdVisoreNoCarosello}-Testo`
            )}
            __deps__={React}
            __host__={__host__}
            __mfeName__={MFE_NAMES.richText}
            isEditMode={isEditMode}
            {...testo}
          />
        </div>
      </div>
      <TpdLinksContainer
        title={title.value.value}
        link1={link1.value.linkElement.destination.value}
        link2={link2.value.linkElement.destination.value}
      >
        {((link1 && link1.value.linkElement.destination.value) ||
          isEditMode) && (
          <TpdCtaBox>
            <TpdCta>
              <ReactMFE.Remote
                id={CommonMFE.generateID(containerID, "cta", 1)}
                __deps__={React}
                __host__={__host__}
                __mfeName__={MFE_NAMES.tpdCta}
                isEditMode={isEditMode}
                {...link1}
              />
            </TpdCta>
          </TpdCtaBox>
        )}
        {((link2 && link2.value.linkElement.destination.value) ||
          isEditMode) && (
          <TpdCtaBox>
            <TpdCta>
              <ReactMFE.Remote
                id={CommonMFE.generateID(containerID, "cta", 2)}
                __deps__={React}
                __host__={__host__}
                __mfeName__={MFE_NAMES.tpdCta}
                isEditMode={isEditMode}
                {...link2}
              />
            </TpdCta>
          </TpdCtaBox>
        )}
      </TpdLinksContainer>
    </div>
  );
};
